var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24023 0H14.8652H15.373L15.7246 0.390625L17.5996 2.26562L17.9902 2.61719V3.125V6.25H15.4902V3.67188L14.3184 2.5H5.49023V6.25H2.99023V1.25V0H4.24023ZM2.99023 15H0.490234V7.5H20.4902V15H17.9902V18.75V20H16.7402H4.24023H2.99023V18.75V15ZM5.49023 15V17.5H15.4902V15V13.75H5.49023V14.375V15ZM16.4277 9.6875V11.5625H18.3027V9.6875H16.4277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a06df70ce9352ab99cb479ee266fc677.svg";
export { ForwardRef as ReactComponent };